import { api } from './api';
import { Recommendation } from '../types';

export interface PlayerDevelopmentRecommendations {
  playerId: string;
  playerName: string;
  positionType: 'outfield' | 'goalkeeper';
  recommendations: Recommendation[];
  generatedAt: string;
}

export const playerDevelopmentService = {
  async getRecommendations(playerId: string, teamId: string): Promise<PlayerDevelopmentRecommendations> {
    const response = await api.get<{ data: PlayerDevelopmentRecommendations }>(
      `/player-development/players/${playerId}/recommendations`,
      { params: { teamId } }
    );
    return response.data.data;
  },
};
